import { SortDirection } from '@angular/material/sort';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class GradedUnitPartialGradesStateModel extends SubentityStateModel {
    filters = {
        list: [],
    };
    totalCount: number;
    pageSize: number;
    pageNumber: number;
    sortBy: string;
    sortOrder: SortDirection;

    constructor() {
        super();

        this.searchTerm = sessionStorage.getItem('gradedUnitPartialGradesSearchTerm');
        this.sortBy = sessionStorage.getItem('gradedUnitPartialGradesSortBy');
        this.sortOrder = sessionStorage.getItem('gradedUnitPartialGradesSortOrder') as SortDirection;
    }
}
